import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import classnames from "classnames";
import { isEmpty } from 'lodash'
import { trackValues } from './../../tracker';
import { trackSiteId, urls } from '../../config';

import { jsonFetch } from '../../utils/fetch';

import { subjectTestFetchIfNeeded, subjectTestSet } from './../../store/subjectTest/actions';
import { profileFetchIfNeeded, profileFetch } from './../../store/profile/actions';
import { usePrevious } from './../../hooks';

import Loader from './../shared/Loader'
import Button from './../shared/Button/index';
import baseStyles from 'custom/base.styl';
import Timer from './../LanguageTest/Timer';
import Radiobutton from './../shared/Radiobutton/index';
import { SHORT_SUBJECT_TYPE } from '../../constants/subjectTypes';


const PageSubjectTest = (props) => {
  const profile = useSelector(state => state.profile.data.user);
  const profileNowTime = useSelector(state => state.profile.data.now);
  const subjTest = useSelector(state => state.subjectTest);
  const loadingProfile = useSelector(state => state.profile.isFetching);
  const loadingTest = useSelector(state => state.subjectTest.isFetching);
  const subjStatus = subjTest.status;
  const isSubmiting = subjTest.isSubmiting;

  const prevStatus = usePrevious(subjStatus || 'testing');
  const [endTime, setEndTime] = useState(null);

  let preferredSubject = null;
  if (profile && profile.profile.subject_type) {
    preferredSubject = profile && SHORT_SUBJECT_TYPE[profile.profile.subject_type];
  }
  const [stateAnswer, setAnswer] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (subjStatus !== prevStatus) {
      setTimeout(() => {
        dispatch(profileFetch())
      }, 2000);
    }
  }, [subjStatus]);

  useEffect(() => {
    if (!profile) {
      dispatch(profileFetchIfNeeded())
    }
    if (profile && profile.profile.subject_test_timestamp) {
      let startTime = moment.unix(profile.profile.subject_test_timestamp)
      let nowTime = moment.unix(profileNowTime)
      if (!startTime) { startTime = nowTime }
      const diff = 15 * 60 * 1000 - nowTime.diff(startTime)
      const endTime = moment().add(diff, 'milliseconds').toISOString()
      setEndTime(endTime);
    }
  }, [profile]);

  useEffect(() => {
    if (!subjTest.answer && !loadingTest) {
      dispatch(subjectTestFetchIfNeeded())
    }
  }, [subjTest]);

  const timeout = () => {
    const data = {
      answer_id: subjTest.answer.answer_id,
      answer: -1,
    }
    trackValues('subject_test_end', true, {
      context: { userId: profile.id, site_id: trackSiteId, preferredSubject, version: profile.scenario_version, is_experied: true },
    });
    dispatch(subjectTestSet(data))
  }

  const _handleOnClickNext = (e) => {
    // const { progress } = subjTest

    // if ((progress.complete + 1) === progress.total) {
    //   trackValues('subject_test_end', true, {
    //     context: { userId: profile.id, site_id: trackSiteId, preferredSubject, version: profile.scenario_version },
    //   });
    // }

    const data = {
      answer_id: subjTest.answer.answer_id,
      answer: stateAnswer,
    }

    dispatch(subjectTestSet(data))
    setAnswer(null)
    dispatch(profileFetch())
  }

  const onCopyHandler = (e) => {
    // if (process.env.NODE_ENV === 'production')
    // if (process.env.NODE_ENV === 'development')

    const answerId = subjTest.answer.answer_id
    const question = subjTest.answer.data.question
    const selectedText = document.getSelection().toString()

    if (selectedText.length > 0) {
      const data = {
        info: { answer_id: answerId, answer: question },
        stage: profile.stage,
        text: selectedText,
      }
      jsonFetch(`${urls.eventLogs}`, data, { method: 'POST' });
    }
  }


  const _handleOnChange = (e) => {
    setAnswer(e.target.value)
  }

  if (loadingProfile || loadingTest) {
    return <Loader absolute />
  }


  if (isEmpty(subjTest.answer)) {
    return null;
  }

  const { answers, progress } = subjTest

  return (
    <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)} onCopy={onCopyHandler}>
      {progress &&
        <div className={baseStyles.test_header}>{progress.complete + 1} / {progress.total}</div>
      }
      <h2 className={baseStyles.test_title}>{subjTest.answer.data.question}</h2>
      {answers &&
        <div className={baseStyles.test_body}>
          {(answers || []).map((number) =>
            <div className={baseStyles.radio_wrap} key={number}>
              <Radiobutton
                checked={stateAnswer === number.toString()}
                onChange={(e) => _handleOnChange(e)}
                type="radio"
                id={subjTest.answer.answer_id}
                name={subjTest.answer.answer_id}
                value={number}
              >
                {subjTest.answer.data[`answer${number}`]}
              </Radiobutton>
            </div>
          )}
        </div>
      }

      <Button onClick={() => _handleOnClickNext()} disabled={isSubmiting || !stateAnswer}>Next</Button>

      {endTime &&
        <div className={baseStyles.test_footer}>Time left: <Timer endTime={endTime} submitTest={() => timeout()} /></div>
      }
    </div>
  )
}

export default PageSubjectTest;



// WEBPACK FOOTER //
// ./src/components/SubjectTest/PageSubjectTest.js